'use strict';

angular
    .module('aq.filters.formatters')
    .filter('minusToZero', function () {
        return function (input) {
            return input < 0 ? 0 : input;
        }
    });